import { stripHtml } from '@shared/utils/strip-html.util';

/**
 * Utility function for Collaboration Hub
 * @param title - The title of the collaboration message
 * @returns An object containing the title and description
 */
export function collabHubTitleDescFormatter(title: string): {
  title: string;
  description: string;
} {
  const formattedTitle = stripHtml(title);
  return {
    description: `Collaboration message on ${formattedTitle}.`,
    title: formattedTitle,
  };
}
